<template>
    <proposal-networks-faq-view />
</template>
<script>
    import ProposalNetworksFaqView from "../data-views/proposals/ProposalNetworksFaqView";
    import NetworksProvider from "../providers/proposal-steps/NetworksProvider";
    export default {
        name: "ProposalNetworksFaqRouterView",
        components: {NetworksProvider, ProposalNetworksFaqView}
    }
</script>
